import {Component, React, useEffect, useState} from 'react';
import { Navigation } from './commons/navigation.tsx';
import ToolsContent from './commons/tools-content-general.tsx';
import { Notifications } from './commons/notifications.tsx';
import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  ContentLayout,
  Popover,
  Flashbar,
  Form,
  SpaceBetween,
  Button,
  ColumnLayout,
  Header,
  HelpPanel,
  Link,
  SideNavigation,
  SplitPanel,
} from '@cloudscape-design/components';
import plant_madrid from './static/plant_madrid_genai.png';
import plant_munich from './static/plant_munich_genai.png';
import plant_berlin from './static/plant_lasvegas.png';
import plant_barcelona from './static/plant_berlin.png';


function ContentBlock({city, img_src, data, description, temperatureC, moisture, humidity, wateredDif, wateredUnit}){

  return(
    
    <div className="plant-block">
      <h2>{city}</h2>
      <img
        src={img_src}
        alt={'Icon of ' + city}
        
        style={{
          maxWidth: '80%', 
          height: 'auto',  
        }}      
      />
      <h3>
        Plant Type:
      </h3>
      <h4>{data.plantType}</h4>
      <ul>
        <li>Temperature: {temperatureC}  C </li> 
        <li>Humidity:  {humidity} %</li>
        <li>Moisture:  {moisture} %</li>
        <li>Last Watered {wateredDif} {wateredUnit} ago</li>
      </ul>
      <SpaceBetween direction="horizontal" size="xs">
                {/* <Button variant="link">Cancel</Button> */}
                <Popover
                  
                  position="top"
                  triggerType="custom"
                  
                  content="This feature is currently disabled to save water (and our plants)."
                >
                  <Button variant="primary" iconAlign="middle">Water me!</Button>
                </Popover>
              </SpaceBetween>
    </div>
  )
}
function getPlantData(){
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", "https://cz1u81blw8.execute-api.eu-central-1.amazonaws.com/test/plants");
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.responseType = "json";
    xhr.onload = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const data = JSON.parse(xhr.response.body);
        console.log(data);
        const plantData = data;
        resolve(plantData);
      } else {
        console.log(`Error: ${xhr.status}`);
        reject(`Error: ${xhr.status}`);
      }
    };
    xhr.send();
  });
}

export default function () {
    const [toolsOpen, setToolsOpen] = useState(false);
    const [navOpen, setNavOpen] = useState(false);
    const [munich, setmunich] = useState({});
    const [barcelona, setbarcelona] = useState({});
    const [madrid, setmadrid] = useState({});
    const [berlin, setberlin] = useState({});
    const [munichDesc, setmunichDesc] = useState(""); //28 more state things needed
    const [barcelonaDesc, setbarcelonaDesc] = useState("");
    const [madridDesc, setmadridDesc] = useState("");
    const [berlinDesc, setberlinDesc] = useState("");
    const [munichTempC, setmunichTempC] = useState(0);
    const [barcelonaTempC, setbarcelonaTempC] = useState(0); // 5 done
    const [madridTempC, setmadridTempC] = useState(0);
    const [berlinTempC, setberlinTempC] = useState(0);
    const [munichHumidity, setmunichHumidity] = useState(0);
    const [barcelonaHumidity, setbarcelonaHumidity] = useState(0);
    const [madridHumidity, setmadridHumidity] = useState(0);
    const [berlinHumidity, setberlinHumidity] = useState(0);
    const [munichMoisture, setmunichMoisture] = useState(0);
    const [barcelonaMoisture, setbarcelonaMoisture] = useState(0);
    const [madridMoisture, setmadridMoisture] = useState(0);
    const [berlinMoisture, setberlinMoisture] = useState(0);
    const [munichWateredLastDifference, setmunichWateredLastDifference] = useState(0);
    const [madridWateredLastDifference, setmadridWateredLastDifference] = useState(0);
    const [barcelonaWateredLastDifference, setbarcelonaWateredLastDifference] = useState(0);
    const [berlinWateredLastDifference, setberlinWateredLastDifference] = useState(0);
    const [munichWateredLastUnit, setmunichWateredLastUnit] = useState("");
    const [madridWateredLastUnit, setmadridWateredLastUnit] = useState("");
    const [barcelonaWateredLastUnit, setbarcelonaWateredLastUnit] = useState("");
    const [berlinWateredLastUnit, setberlinWateredLastUnit] = useState("");

    useEffect(() => {
          // Callsomething
          getPlantData().then((response) => {
            let munich = response.munich;
            let berlin = response.lasvegas;
            let madrid = response.madrid;
            let barcelona = response.barcelona;
            let munichDesc = response.munich.information.description;
            let berlinDesc = response.lasvegas.information.description;
            let madridDesc = response.madrid.information.description;
            let barcelonaDesc = response.barcelona.information.description;
            let munichTempC = response.munich.metrics.temperatureC;
            let barcelonaTempC = response.barcelona.metrics.temperatureC;
            let madridTempC = response.madrid.metrics.temperatureC;
            let berlinTempC = response.lasvegas.metrics.temperatureC;
            let munichHumidity = response.munich.metrics.humidity;
            let barcelonaHumidity = response.barcelona.metrics.humidity;
            let madridHumidity = response.madrid.metrics.humidity;
            let berlinHumidity = response.lasvegas.metrics.humidity;
            let munichMoisture = response.munich.metrics.moisture;
            let barcelonaMoisture = response.barcelona.metrics.moisture;
            let madridMoisture = response.madrid.metrics.moisture;
            let berlinMoisture = response.lasvegas.metrics.moisture;
            let munichWateredLastDifference = response.munich.wateredLast.difference_pst;
            let munichWateredLastUnit = response.munich.wateredLast.unit_pst;
            let barcelonaWateredLastDifference = response.barcelona.wateredLast.difference_pst;
            let barcelonaWateredLastUnit = response.barcelona.wateredLast.unit_pst;
            let madridWateredLastDifference = response.madrid.wateredLast.difference_pst;
            let madridWateredLastUnit = response.madrid.wateredLast.unit_pst;
            let berlinWateredLastDifference = response.lasvegas.wateredLast.difference_pst;
            let berlinWateredLastUnit = response.lasvegas.wateredLast.unit_pst;
            //Now Set the state
            //AllData
            setmunich(munich);
            setbarcelona(barcelona);
            setmadrid(madrid);
            setberlin(berlin);
            //Desc
            setmunichDesc(munichDesc);
            setbarcelonaDesc(barcelonaDesc);
            setmadridDesc(madridDesc);
            setberlinDesc(berlinDesc);
            //TempC
            setmunichTempC(munichTempC);
            setbarcelonaTempC(barcelonaTempC);
            setmadridTempC(madridTempC);
            setberlinTempC(berlinTempC);
            //Humidity
            setmunichHumidity(munichHumidity);
            setbarcelonaHumidity(barcelonaHumidity);
            setmadridHumidity(madridHumidity);
            setberlinHumidity(berlinHumidity);
            //Moisture
            setmunichMoisture(munichMoisture);
            setbarcelonaMoisture(barcelonaMoisture);
            setmadridMoisture(madridMoisture);
            setberlinMoisture(berlinMoisture);
            //WateredDiff
            setmunichWateredLastDifference(munichWateredLastDifference);
            setmadridWateredLastDifference(madridWateredLastDifference);
            setbarcelonaWateredLastDifference(barcelonaWateredLastDifference);
            setberlinWateredLastDifference(berlinWateredLastDifference);
            //WateredUnit
            setmunichWateredLastUnit(munichWateredLastUnit);
            setmadridWateredLastUnit(madridWateredLastUnit);
            setbarcelonaWateredLastUnit(barcelonaWateredLastUnit);
            setberlinWateredLastUnit(berlinWateredLastUnit);


        })
      
  
    }, []); // Empty dependency array ensures this effect runs only once on mount


    return (
        <AppLayout
          breadcrumbs={
            <BreadcrumbGroup
              items={[
                { text: 'Plantly', href: '#' },
                { text: 'Plants', href: '#' },
              ]}
            />
          }
          navOpen={navOpen}
          onNavChange={({ detail }) => setNavOpen(detail.open)}
          navigation={<Navigation activeHref="/plantsview" />}
          notifications={<Notifications />}
          toolsOpen={toolsOpen}
          onToolsChange={({ detail }) => setToolsOpen(detail.open)}
          tools={ToolsContent}
          contentType="form"
          content={
            <ContentLayout header={<Header variant="h1">Plant View</Header>}>
                {/* <Container
                    header={
                    <Header
                        variant="h2"
                        //info={<InfoLink onFollow={handleInfoClick} />}
                        description="Click on Info to learn more about the services used."
                    >
                        Explore the AWS services used by Plantly!
                    </Header>
                    }
                >
                
                </Container> */}
                {/* <ContentLayout header={<Header variant="h1">Detailed Plant View</Header>}> */}
                <ContentLayout>
        <form onSubmit={event => event.preventDefault()}>
          <Form
            actions={
              <SpaceBetween direction="horizontal" size="xs">
                {/* <Button variant="link">Cancel</Button> */}
                {/* <Button variant="primary">Add plant</Button> */}
              </SpaceBetween>
            }
          >
            
            <Container
              header={
                <Header
                  variant="h2"
                  description="Quickly find information about different plants, understand the plant type and current metrics."
                >
                  Details
                </Header>
              }
            >
              <ColumnLayout columns={4} variant="text-grid">
                <div>
                  <ContentBlock city="Madrid" img_src={plant_madrid} data={madrid} description={madridDesc} humidity={madridHumidity} temperatureC={madridTempC} moisture={madridMoisture} wateredDif={madridWateredLastDifference} wateredUnit={madridWateredLastUnit} />
                </div>
                <div>
                  <ContentBlock city="Munich" img_src={plant_munich} data={munich} description={munichDesc} humidity={munichHumidity} temperatureC={munichTempC} moisture={munichMoisture} wateredDif={munichWateredLastDifference} wateredUnit={munichWateredLastUnit} />
                </div>
                <div>  
                  <ContentBlock city="Barcelona" img_src={plant_munich} data={barcelona} description={barcelonaDesc} humidity={barcelonaHumidity} temperatureC={barcelonaTempC} moisture={barcelonaMoisture} wateredDif={barcelonaWateredLastDifference} wateredUnit={barcelonaWateredLastUnit} />
                </div>
                <div>
                  <ContentBlock city="Berlin" img_src={plant_berlin} data={berlin} description={berlinDesc} humidity={berlinHumidity} temperatureC={berlinTempC} moisture={berlinMoisture} wateredDif={berlinWateredLastDifference} wateredUnit={berlinWateredLastUnit} />
                </div>
              </ColumnLayout>
              {/* <ColumnLayout columns={2} variant="text-grid">
                <div>
                  
                  <ContentBlock city="Madrid" img_src={plant_madrid} data={madrid} description={madridDesc} humidity={madridHumidity} temperatureC={madridTempC} moisture={madridMoisture} wateredDif={madridWateredLastDifference} wateredUnit={madridWateredLastUnit} />
                </div>
                <div>
                  
                  <ContentBlock city="Munich" img_src={plant_munich} data={munich} description={munichDesc} humidity={munichHumidity} temperatureC={munichTempC} moisture={munichMoisture} wateredDif={munichWateredLastDifference} wateredUnit={munichWateredLastUnit} />
                </div>
              </ColumnLayout>
              <ColumnLayout columns={2} variant="text-grid">
                <div>  
                  <ContentBlock city="Barcelona" img_src={plant_barcelona} data={barcelona} description={barcelonaDesc} humidity={barcelonaHumidity} temperatureC={barcelonaTempC} moisture={barcelonaMoisture} wateredDif={barcelonaWateredLastDifference} wateredUnit={barcelonaWateredLastUnit} />
                </div>
                <div>
                  <ContentBlock city="Berlin" img_src={plant_berlin} data={berlin} description={berlinDesc} humidity={berlinHumidity} temperatureC={berlinTempC} moisture={berlinMoisture} wateredDif={berlinWateredLastDifference} wateredUnit={berlinWateredLastUnit} />
                </div>
              </ColumnLayout> */}
            </Container>
          </Form>
        </form>
      </ContentLayout>
            </ContentLayout>
          }
        />
    );
  }





